/**
 * @format
 * @flow
 */
import React from "react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import DateJp from "UltraDate.js";
import { Editor } from "react-draft-wysiwyg";
import { Link } from "react-router-dom";
import draftHtml from "draftjs-to-html";
import { EditorState, } from 'draft-js';
import { stateFromHTML } from 'draft-js-import-html';
import { stateToHTML } from 'draft-js-export-html';
import * as RT from "../../../constants/Routing";
import * as Actions from "../../../actions/Template";
import Template from "../../../components/Template/AfterLoginTemplate";
import TemplateModal from "../../../components/Common/TemplateModal";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Tooltip from 'react-simple-tooltip';

DateJp.setDefaultLocale("ja");


class Component extends React.Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);
        this.state = {
            isTemplateModal: false,
            formErrors: { categoryTitle: " ", content: " " },
            belongInput1: "身分証明書当日持参 (免許、パスポート等)",
            belongInput2: "筆記用具",
            belongInput3: "水分補給用の飲み物 (フタつき)",
            precautionInput1: "身分証明書の提示必須",
            precautionInput2: "学生不可",
            precautionInput3: "露出度の高い服装禁止",
            categoryTitle: "",
            belongCount:3,
            precautionCount:3,
            allValid: false,
            contentState: ""
        };
        this.currentUser = JSON.parse(localStorage.getItem("current_user"));
    }

    componentDidMount() {
        var contentState = stateFromHTML("<p><span style=\"color: rgb(0,0,0);background-color: transparent;font-size: 11pt;font-family: Arial;\">この度は当施設のタスクにご応募いただきまして誠にありがとうございます。</span><br></p>\n" +
            "<p><span style=\"color: rgb(0,0,0);background-color: transparent;font-size: 11pt;font-family: Arial;\">当日の注意事項を下記でご確認ください</span><br></p>\n" +
            "<p><span style=\"color: rgb(0,0,0);background-color: transparent;font-size: 11pt;font-family: Arial;\">【当日の集合】タスク開始前に簡単な説明を行いますので開始時刻の15分前にお越しください。</span></p>\n" +
            "<p><span style=\"color: rgb(0,0,0);background-color: transparent;font-size: 11pt;font-family: Arial;\">到着後はスタッフに「タスケル」から来ました。とお声かけ下さい。</span><br></p>\n" +
            "<p><span style=\"color: rgb(0,0,0);background-color: transparent;font-size: 11pt;font-family: Arial;\">【服装】作業のしやすい服装でお越しください。露出度の高い短パンやスカートはお控えください。</span></p>\n" +
            "<p><span style=\"color: rgb(0,0,0);background-color: transparent;font-size: 11pt;font-family: Arial;\">ロングヘアの方は後ろで一つにまとめていただきます。</span><br></p>\n" +
            "<p><span style=\"color: rgb(0,0,0);background-color: transparent;font-size: 11pt;font-family: Arial;\">【緊急時連絡】遅刻は厳禁です。緊急時は施設連絡先までご連絡ください。</span><br></p>");
        var editorState = EditorState.createWithContent(contentState);
        this.setState({contentState:editorState})
    }

    // eslint-disable-next-line react/no-deprecated,no-undef
    componentWillReceiveProps(nextProps: Props, nextContext: *): * {
        if (
            nextProps.Template.Template != undefined &&
            nextProps.Template.Template.length > 0 &&
            nextProps.Template.Template === "正常に作成されました"
        ) {
            this.props.reseTemplate();
            this.props.history.push(RT.TEMPLATE_PATH);
        }
    }

    _onCancelClick = () => {
        this.setState({ isTemplateModal: false });
    };

    setValue = e => {
        this.fillValue(e.target.name, e.target.value);
    };

    fillValue(name, value) {
        this.setState({ [name]: value }, () => {
            this._validateField(name, value);
        });
    }

    _validateField = (fieldName, value) => {
        const { formErrors } = this.state;
        const fieldValidationErrors = formErrors;
        switch (fieldName) {
            case "categoryTitle":
                fieldValidationErrors.categoryTitle =
                    value.length > 0 ? " " : "* カテゴリーを選択してください";
                break;
            default:
                break;
        }
        this.setState(
            {
                formErrors: fieldValidationErrors
            },
            this.validateForm
        );
    };

    validateForm() {
        const { questionTitle, categoryTitle, contentState } = this.state;

        if (categoryTitle && contentState) {
            if (contentState.getCurrentContent().hasText()) {
                this.setState({ allValid: true });
            } else {
                this.setState({ allValid: false });
            }
        } else {
            this.setState({ allValid: false });
        }
    }

    // eslint-disable-next-line consistent-return,class-methods-use-this
    _errorClass(error) {
        if (error !== undefined) {
            return error.length === 0 ? "" : "has-error";
        }
    }

    _onPublishClick = status => {
        const {  categoryTitle, contentState, belongCount, precautionCount } = this.state;

        let arrBelong = []
        for (let i=0; i < belongCount; i++) {
            arrBelong = [...arrBelong, this.state[`belongInput${i + 1}`]]
        }
        let arrPrecaution = []
        for (let i=0; i < precautionCount; i++) {
            arrPrecaution = [...arrPrecaution, this.state[`precautionInput${i + 1}`]]
        }
        const body = {
            enterpriseId: this.currentUser.enterpriseId,
            templateName: categoryTitle,
            templateMessage: stateToHTML(contentState.getCurrentContent()),
            bringList: arrBelong,
            precautionList: arrPrecaution,
            templateStatus: status
        };
        const token = this.currentUser.accessToken;
        // eslint-disable-next-line react/destructuring-assignment
        this.props.postTemplate(body,token);
    };

    onContentStateChange = contentState => {
        this.setState({ contentState });
        this._validateField("contentState", contentState);
    };

    renderBelongInput = () => {
        const {
            formErrors,
            belongCount,
        } = this.state;
        const fields = [];
        for (let i=0; i < belongCount; i++) {
            fields.push(
                <div>
                    <input
                        type="text"
                        className={`template_belong_div ${this._errorClass(
                            formErrors.questionTitle
                        )}`}
                        id={`belongInput${i + 1}`}
                        name={`belongInput${i + 1}`}
                        placeholder=""
                        value={ this.state[`belongInput${i + 1}`]}
                        onChange={this.setValue}
                    />
                </div>
            )
        }
        return fields
    }

    renderPrecautionInput = () => {
        const {
            formErrors,
            precautionCount,
        } = this.state;
        const fields = [];
        for (let i=0; i < precautionCount; i++) {
            fields.push(
                <div>
                    <input
                        type="text"
                        className={`template_belong_div ${this._errorClass(
                            formErrors.questionTitle
                        )}`}
                        id={`precautionInput${i + 1}`}
                        name={`precautionInput${i + 1}`}
                        placeholder=""
                        value={ this.state[`precautionInput${i + 1}`]}
                        onChange={this.setValue}
                    />
                </div>
            )
        }
        return fields
    }

    render = () => {
        const {
            formErrors,
            isTemplateModal,
            categoryTitle,
            allValid,
        } = this.state;
        return (
            <Template>
                <TemplateModal
                    isOpen={isTemplateModal}
                    okClickHandler={() => this._onCancelClick()}
                    onPublishClick={() => {
                        this._onPublishClick(2);
                    }}
                    titleText="このテンプレートを公開しますか？
公開後はタスク作成ページで承認したタスクルーに送る注意事項として選択することが可能になります。"
                />
                <div className="template-main">
                    <h2 class="title">注意事項テンプレート作成</h2>
                    <h3 class="sub-title">承認済みのタスクルーに送る注意事項やメッセージなどのテンプレートを作成・編集します</h3>
                    <div className="template-title">
                        <input
                            type="text"
                            className={`form-control template-input ${this._errorClass(
                                formErrors.questionTitle
                            )}`}
                            id="categoryTitle"
                            name="categoryTitle"
                            placeholder="テンプレートのタイトルを入力してください"
                            value={categoryTitle}
                            onChange={this.setValue}
                        />
                        <Tooltip content="タイトルは施設専用でタスクルーには表示されません。">
                            <i className="fas fa-info-circle" />
                        </Tooltip>
                        <label className="template_error_text">{formErrors.categoryTitle}</label>
                    </div>
                    <div className="editor-block">
                        <p>承認したタスクルーに対して感謝の言葉や当日の注意事項等を書き込みましょう。</p>
                        <Tooltip content="テンプレートを編集することも、新規で作成することも可能です。">
                            <i className="fas fa-info-circle" />
                        </Tooltip>
                        <Editor
                            editorClassName="template-editor"
                            editorState={this.state.contentState}
                            onEditorStateChange={this.onContentStateChange}
                        />
                    </div>
                    <div>
                        <label className="template_belong_text">持ち物</label>
                    </div>
                    <div>
                        {this.renderBelongInput()}
                    </div>
                    <div className="row add-more-div">
                        <div className="add-more" onClick={() => this.setState({belongCount: this.state.belongCount + 1})}>
                            + 追加
                        </div>
                        <div className="minus-more" onClick={() => this.state.belongCount > 3 ? this.setState({belongCount: this.state.belongCount - 1}) : ""}>
                             - 削除
                        </div>
                    </div>
                    <div>
                        <label className="template_belong_text">条件・注意事項</label>
                    </div>
                    <div>
                        {this.renderPrecautionInput()}
                    </div>
                    <div className="row add-more-div">
                        <div className="add-more" onClick={() => this.setState({precautionCount: this.state.precautionCount + 1})}>
                            + 追加
                        </div>
                        <div className="minus-more" onClick={() => this.state.precautionCount > 3 ?this.setState({precautionCount: this.state.precautionCount - 1}) : ""}>
                            - 削除
                        </div>
                    </div>
                    <label className="template_error_text">{formErrors.content}</label>
                    <div className="template-button row">
                        {/* eslint-disable-next-line react/button-has-type */}
                        <button
                            disabled={!allValid}
                            className="btn btn-gray btn-md btn-space"
                            onClick={() => this._onPublishClick(1)}
                        >
                            非公開
                        </button>
                        {/* eslint-disable-next-line react/button-has-type */}
                        <button
                            disabled={!allValid}
                            onClick={() => this.setState({ isTemplateModal: true })}
                            className="btn btn-green btn-md"
                        >
                            公開
                        </button>
                    </div>
                </div>
            </Template>
        );
    };
}

const mapStateToProps = state => state;
const mapDispatchToProps = dispatch => bindActionCreators(Actions, dispatch);

const Container = connect(mapStateToProps, mapDispatchToProps)(Component);

export default withRouter(Container);

